import { render } from "./edit-simple.vue?vue&type=template&id=07b61466&scoped=true"
import script from "./edit-simple.vue?vue&type=script&lang=js"
export * from "./edit-simple.vue?vue&type=script&lang=js"

import "./edit-simple.vue?vue&type=style&index=0&id=07b61466&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.16_vue@3.5.13_typescript@5.1.6__webpack@5.99.9/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07b61466"]])

export default __exports__